import React from 'react';
import { CheckCircle2, Clock, Smartphone, Building2, MapPin, BookOpen } from 'lucide-react';

const BadgesSection = () => {
  const badges = [
    { icon: CheckCircle2, text: 'Tecnologia Homologada' },
    { icon: Clock, text: 'Suporte 24 Horas' },
    { icon: Smartphone, text: 'App iOS e Android' },
    { icon: Building2, text: 'Empresa Especializada' },
    { icon: MapPin, text: 'Cobertura Nacional' },
    { icon: BookOpen, text: 'Guia Completo' }
  ];

  return (
    <section className="bg-[#0a0f1e] py-8 border-y border-blue-500/10">
      <div className="container mx-auto px-6 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {badges.map((badge, index) => {
            const Icon = badge.icon;
            return (
              <div
                key={index}
                className="flex flex-col items-center gap-3 p-4 rounded-lg hover:bg-blue-950/30 transition-colors group"
              >
                <div className="w-12 h-12 bg-blue-600/20 rounded-full flex items-center justify-center group-hover:bg-blue-600/30 transition-colors">
                  <Icon className="w-6 h-6 text-blue-400" />
                </div>
                <span className="text-gray-300 text-sm text-center font-medium">{badge.text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BadgesSection;
